import { IApplicationState } from '../../types/redux';

export function selectPageContainer(state: IApplicationState) {
  return state.page.pageContainer;
}
